import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-px-line mt-20">
      <div className="mk-container py-10 grid gap-8 sm:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <Logo size={32} />
            <div>
              <div className="font-display font-bold text-sm">PX7 Training</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-px-text-muted">
                Copenhagen · DK
              </div>
            </div>
          </div>
          <p className="text-xs text-px-text-soft leading-relaxed">
            Science-based running plans that adjust to your training, time and recovery.
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-px-text-muted mb-3">Site</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-px-text-soft hover:text-px-text">Home</Link></li>
            <li><Link to="/science" className="text-px-text-soft hover:text-px-text">Science</Link></li>
            <li><Link to="/method" className="text-px-text-soft hover:text-px-text">The method</Link></li>
            <li><Link to="/articles" className="text-px-text-soft hover:text-px-text">Articles</Link></li>
            <li><Link to="/pricing" className="text-px-text-soft hover:text-px-text">Pricing</Link></li>
            <li><Link to="/about" className="text-px-text-soft hover:text-px-text">About</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-px-text-muted mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/#newsletter" className="text-px-text-soft hover:text-px-text">Newsletter</Link></li>
            <li><a href="mailto:jorgen@larsen.zone" className="text-px-text-soft hover:text-px-text">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-px-text-muted mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="text-px-text-soft hover:text-px-text">Privacy</Link></li>
            <li><Link to="/terms" className="text-px-text-soft hover:text-px-text">Terms</Link></li>
            <li><Link to="/cookies" className="text-px-text-soft hover:text-px-text">Cookies</Link></li>
          </ul>
        </div>
      </div>
      <div className="mk-container py-5 border-t border-px-line text-[11px] text-px-text-muted flex flex-wrap justify-between gap-2">
        <span>© {new Date().getFullYear()} PX7 Training · Jørgen Larsen</span>
        <span>
          Personal coaching: {" "}
          <a
            href="https://lobementor.com"
            className="text-px-text-soft hover:text-px-text"
            target="_blank"
            rel="noreferrer noopener"
          >
            LØBEMENTOR
          </a>
          {" · Made by "}
          <a
            href="https://px7.digital"
            className="text-px-text-soft hover:text-px-text"
            target="_blank"
            rel="noreferrer noopener"
          >
            PX7 Digital
          </a>
        </span>
      </div>
    </footer>
  );
}
